define.alias("ember-composable-helpers/helpers/take", "media/helpers/take");